import {
    formatNumber,
} from '../../../helpers/functions';
import Moment from "moment";

export function createBaloonTemplate(property, isVisible = true) {
    let propertyData = getPropertyData(property),
        address = propertyData.address,
        propStateCity = (address || {}).city || '';

    if (address.state) {
        propStateCity += (propStateCity ? ', ' : '') + address.state;
    } else if (address.county) {
        propStateCity += (propStateCity ? ', ' : '') + address.county;
    }

    return `<div class="card property-card">
    <div class="row no-gutters">
       <div class="col">
          <div>
             <div data-displaysingleimage="true">
                <div class="labels">
                    ${getBadges(property, isVisible)}
                </div>
                
               <div 
                   class="b-skeleton b-skeleton-img b-skeleton-animate-wave property-card-balloon-image-loader" 
                   role="status"></div>
             </div>
          </div>
       </div>
    </div>
    <div class="row no-gutters">
      <div class="pl-3 pb-2 pt-2 col-9">
        <div class="details-container d-block card-group">
          <div class="row">
            <div class="col">
              <div class="price-details card-group">
                <p class="card-text price m-0">
                  ${propertyData.price}
                </p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="card-text address">
                  <div class="row">
                    <div class="address col">
                        ${address && address.street ? address.street : address && address.areaCode ? address.areaCode : ''}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      ${propStateCity}
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="favorite pl-2 pt-4 col-3">
        <div class="property-listing-card-favorite-button float-right mr-xl-2">
          <div class="">
            <button type="button" class="btn button btn-link">
              <i class="far fa-heart fav-btn"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="row no-gutters">
      <div class="col">
        <div class="card-footer house-info">
          <p class="card-text house-info-text">
              <span class="house-info-elem">
                <span class="strong">${propertyData.bedrooms}</span> beds
              </span>
            <span class="house-info-elem">
                  <span class="strong">${propertyData.bathrooms}</span> baths
              </span>
            <span class="house-info-elem">
                  <span class="strong">${propertyData.size}</span> ${propertyData.sizeUnit}
              </span>
          </p>
        </div>
      </div>
    </div>
  </div>`;
}

function getPropertyData(property) {
    let sizeUnitsMapping = {
        'square feet': 'sqft',
    };
    let price = property.price;
    if (property.isSold) {
        price = property.details.salePrice;
    }
    price = price ? formatNumber(price) : '---';
    return {
        price: price,
        address: getAddress(property),
        bathrooms: property.bathrooms,
        bedrooms: property.bedrooms,
        sizeUnit: sizeUnitsMapping[property.sizeUnits],
        size: formatSize(property.size),
    };
}


function getAddress(property) {
    let propDetails = property.details || {};
    return propDetails.address || propDetails;
}

function formatSize(value) {
    return (value || '').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function getBadges(property, notCore = true) {
    let badges = [];

    if (!notCore) {
        let myHomeBadge = {
            text: 'MY HOME',
            variant: 'success',
        };
        badges.push(myHomeBadge);
    }
    else {
        if (property.details.daysOnMarket && property.details.daysOnMarket <= 7) {
            let newBadge = {
                text: 'NEW',
                variant: 'blue',
            };
            badges.push(newBadge);
        }
        if (!!property.offMarketAt || !!property.off_market_at) {
            let newBadge = {
                text: 'OFF MARKET',
            };
            badges.push(newBadge);
        }
        if (!!property.isPending) {
            let newBadge = {
                text: 'PENDING',
                variant: 'red',
            };
            badges.push(newBadge);
        }
        if (property.isSold) {
            let text = 'SOLD ';
            if (property.details.saleDate) {
                const date = Moment.unix(property.details.saleDate);
                text += date.format('ll');
            }
            let soldBadge = {
                variant: 'red',
                text: text,
            };
            badges = [soldBadge];
        }
    }

    let html = '';

    badges.forEach((badge) => {
       html += `<span class="badge m-1 text-uppercase ${'badge-' + (badge.variant ? badge.variant : 'gray-900')} badge-pill">
        ${badge.text ? badge.text : ''}
    </span>`;
    });


    return html;
}
